import { render } from "./SuccessScreen.vue?vue&type=template&id=271ac708&scoped=true"
import script from "./SuccessScreen.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.vue?vue&type=script&lang=js"

import "./SuccessScreen.vue?vue&type=style&index=0&id=271ac708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271ac708"]])

export default __exports__